import {
    AppBar,
    Avatar,
    Button,
    Container,
    CssBaseline,
    Drawer,
    Grid,
    IconButton,
    ThemeProvider,
    Toolbar
} from "@mui/material";
import theme from './theme';
import logo from './images/logo.svg';
import {
    HashRouter as Router, Routes, Route, Link as RouterLink
} from "react-router-dom";

import HomePage from "./Coineus/views/HomePage";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import Web3 from "web3";
import useWeb3Modal from "./Coineus/hooks/useWeb3Modal";
import {
    resetWallet, updateWalletAddress, updateWalletChain, updateWalletProviderType,
} from "./Coineus/redux/slices/coineusSlice";
import getPairPrices from "./Coineus/utils/get_prices";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import getUserBalances from "./Coineus/utils/get_balances";
import Admin from "./Coineus/views/Admin";
import CEUSONEFaucet from "./Coineus/views/Faucets/CEUSONEFacuet";
import ChainSelector from "./Coineus/components/ChainSelector";
import CoineusMenu from "./Coineus/components/CoineusMenu";

export default function Coineus() {

    const dispatch = useDispatch();
    const {wallet} = useSelector(state => state.coineus);


    const [menuOpen, setMenuOpen] = useState(false);
    const [web3Modal, setWeb3Modal] = useState(null);
    const web3ModalProvider = useWeb3Modal();

    useEffect(() => {
        if (window.ethereum) {
            connectProvider(window.ethereum)
        }
        changeWeb3Modal();
    }, []);

    async function changeWeb3Modal() {
        const web3mod = await web3ModalProvider.getWeb3Modal();
        if (web3mod.providerController.cachedProvider) {
            const provider = await web3mod.connect()
            await connectProvider(provider)
        }
        setWeb3Modal(web3mod);
    }

    async function connectWallet() {
        const provider = await web3Modal.connect();
        await connectProvider(provider)
    }

    const connectProvider = async (provider) => {
        window.provider = provider
        const web3 = new Web3(provider);
        subscribeProvider(provider)
        const accounts = await web3.eth.getAccounts();
        if (accounts && accounts.length) {
            //set wallet address
            //
            dispatch(updateWalletAddress(accounts[0]))
        }
        const chainId = parseInt(await web3.eth.net.getId())
        dispatch(updateWalletChain(chainId));
        dispatch(updateWalletProviderType(!!provider.bridge ? 'walletconnect' : 'injected'))
    }

    const subscribeProvider = (provider) => {
        provider.on("close", () => {
            clearWallet();
        });

        provider.on("accountsChanged", async (acc) => {
            if (window.provider) {
                dispatch(updateWalletAddress(acc[0]))
            }
        });

        provider.on("chainChanged", async (networkId) => {
            if (window.provider) {
                const chainId = parseInt(networkId)
                dispatch(updateWalletChain(chainId));
            }
        });
    }

    const clearWallet = async () => {
        const web3 = new Web3(window.provider);
        if (web3 && web3.currentProvider && web3.currentProvider.close) {
            await web3.currentProvider.close();
        }
        dispatch(resetWallet())
        await web3Modal.clearCachedProvider();
        window.provider = null;
    }

    //updates pricing
    useEffect(() => {
        getPairPrices();
        const interval = setInterval(getPairPrices, 60000)
        return () => clearInterval(interval);
    }, [wallet.address]);

    //updates balances
    useEffect(() => {
        getUserBalances(wallet.address);
        const interval = setInterval(() => getUserBalances(wallet.address), 60000)
        return () => clearInterval(interval);
    }, [wallet.address]);

    return (<ThemeProvider theme={theme}>
        <CssBaseline/>
        <Router>
            <AppBar enableColorOnDark>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => setMenuOpen(true)}
                    >
                        <MenuIcon/>
                    </IconButton>

                    <RouterLink
                        to={`/`}
                        style={{textDecoration: 'none', display: 'flex'}}
                    >
                        <Avatar src={logo} height={40}/>
                    </RouterLink>
                    <div style={{flexGrow: 1}}/>
                    <ChainSelector />
                    {wallet.address ? <Button
                        variant="outlined"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            clearWallet();
                        }}
                        style={{marginLeft:10}}
                    >0X...{wallet.address?.substr(-6)}</Button> : <Button
                        variant="outlined"
                        color="inherit"
                        size="small"
                        onClick={() => connectWallet()}>Connect</Button>}
                </Toolbar>
            </AppBar>
            <Grid container style={{marginTop: 64}}>
                <Grid item xs={12}>
                    <Routes>
                        <Route
                            path={`/`}
                            exact={true}
                            element={<Container><HomePage/></Container>}
                        />
                        <Route
                            path={`/admin`}
                            exact={true}
                            element={<Container maxWidth="xs"><Admin/></Container>}
                        />
                        <Route
                            path={`/faucet/ceusone`}
                            exact={true}
                            element={<Container maxWidth="xs"><CEUSONEFaucet /></Container>}
                        />
                    </Routes>
                </Grid>
            </Grid>

            <Drawer
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                PaperProps={{style: {minWidth: 240, backgroundColor: '#000', backgroundImage: 'none'}}}
                onClick={() => setMenuOpen(false)}
            >
                <IconButton onClick={() => setMenuOpen(false)} style={{alignSelf: 'end'}}>
                    <CloseIcon/>
                </IconButton>

                <CoineusMenu />

            </Drawer>
        </Router>
    </ThemeProvider>)
}